import { Component, Input, OnInit } from '@angular/core';
import { WorkLineDto } from '@app/generated/model';
import { WorkOrderDetailsDto } from '@app/generated/model';
import { UntypedFormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { FeatureFlagService } from '@app/core/services/feature-flag.service';
import { FeatureFlagKey } from '@dwo/enums';

@Component({
  selector: 'app-work-line',
  templateUrl: './work-line.component.html',
  styleUrls: ['./work-line.component.scss'],
  standalone: false,
})
export class WorkLineComponent implements OnInit {
  @Input() workLine: WorkLineDto;
  @Input() workOrder: WorkOrderDetailsDto;

  public selectAllObjects = new UntypedFormControl(false);
  private onDestroy = new Subject<void>();

  constructor(private featureFlagService: FeatureFlagService) {}

  ngOnInit(): void {}

  isPercentageWorkLine() {
    return this.workLine.progressType === '0';
  }

  isCableWorkLine() {
    return (
      this.isCableWorkLineFeatureEnabled() && (this.workLine.progressType === 'C' || this.workLine.progressType === 'D')
    );
  }

  private isCableWorkLineFeatureEnabled(): boolean {
    return this.featureFlagService.isEnabled(FeatureFlagKey.EnableCableWorkLine, this.workOrder?.projectId);
  }

  // isQuantityWorkLine() {
  //   return this.workLine.progressType === '1' ;
  // }
}
